/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tXkSR39sgCDWSitZxC5xFV
// Component: en2IIw2C3_aI

import * as React from "react";

import {
  Flex as Flex__,
  MultiChoiceArg,
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { BaseDialog } from "@plasmicpkgs/react-aria/skinny/registerDialog";
import ListSectionSeparator from "../../components/ListSectionSeparator"; // plasmic-import: uG5_fPM0sK/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "../PP__plasmickit_design_system.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import sty from "./PlasmicDialog.module.css"; // plasmic-import: en2IIw2C3_aI/css

createPlasmicElementProxy;

export type PlasmicDialog__VariantMembers = {
  show: "header" | "footer";
};
export type PlasmicDialog__VariantsArgs = {
  show?: MultiChoiceArg<"header" | "footer">;
};
type VariantPropType = keyof PlasmicDialog__VariantsArgs;
export const PlasmicDialog__VariantProps = new Array<VariantPropType>("show");

export type PlasmicDialog__ArgsType = {
  header?: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
};
type ArgPropType = keyof PlasmicDialog__ArgsType;
export const PlasmicDialog__ArgProps = new Array<ArgPropType>(
  "header",
  "content",
  "footer"
);

export type PlasmicDialog__OverridesType = {
  root?: Flex__<typeof BaseDialog>;
  scrollableContent?: Flex__<"div">;
};

export interface DefaultDialogProps {
  header?: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
  show?: MultiChoiceArg<"header" | "footer">;
  className?: string;
}

const $$ = {};

function PlasmicDialog__RenderFunc(props: {
  variants: PlasmicDialog__VariantsArgs;
  args: PlasmicDialog__ArgsType;
  overrides: PlasmicDialog__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "show",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.show,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <BaseDialog
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        "root_reset_tXkSR39sgCDWSitZxC5xFV",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootshow_footer]: hasVariant($state, "show", "footer"),
          [sty.rootshow_header]: hasVariant($state, "show", "header"),
        }
      )}
    >
      {(hasVariant($state, "show", "header") ? true : false)
        ? renderPlasmicSlot({
            defaultContents: (
              <div className={classNames("all", "__wab_text", sty.text__yugkh)}>
                {"Header"}
              </div>
            ),
            value: args.header,
          })
        : null}
      <ListSectionSeparator
        className={classNames(
          "__wab_instance",
          sty.listSectionSeparator__ib9Q,
          {
            [sty.listSectionSeparatorshow_header__ib9Q9B6S6]: hasVariant(
              $state,
              "show",
              "header"
            ),
          }
        )}
      />

      <div
        data-plasmic-name={"scrollableContent"}
        data-plasmic-override={overrides.scrollableContent}
        className={classNames("all", sty.scrollableContent, {
          [sty.scrollableContentshow_header]: hasVariant(
            $state,
            "show",
            "header"
          ),
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <div className={classNames("all", sty.freeBox___865Cg)}>
              <div className={classNames("all", "__wab_text", sty.text__zmnZe)}>
                {"This is a Modal!"}
              </div>
              <div className={classNames("all", "__wab_text", sty.text__gHmJ)}>
                {
                  "You can put anything here!\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                }
              </div>
            </div>
          ),
          value: args.content,
        })}
      </div>
      <ListSectionSeparator
        className={classNames(
          "__wab_instance",
          sty.listSectionSeparator___9CStf,
          {
            [sty.listSectionSeparatorshow_footer___9CStfh6DAq]: hasVariant(
              $state,
              "show",
              "footer"
            ),
            [sty.listSectionSeparatorshow_header___9CStf9B6S6]: hasVariant(
              $state,
              "show",
              "header"
            ),
          }
        )}
      />

      {(hasVariant($state, "show", "footer") ? true : false)
        ? renderPlasmicSlot({
            defaultContents: (
              <div className={classNames("all", "__wab_text", sty.text__uLxOp)}>
                {"Footer"}
              </div>
            ),
            value: args.footer,
          })
        : null}
    </BaseDialog>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "scrollableContent"],
  scrollableContent: ["scrollableContent"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof BaseDialog;
  scrollableContent: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDialog__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDialog__VariantsArgs;
    args?: PlasmicDialog__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicDialog__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicDialog__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDialog__ArgProps,
          internalVariantPropNames: PlasmicDialog__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicDialog__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDialog";
  } else {
    func.displayName = `PlasmicDialog.${nodeName}`;
  }
  return func;
}

export const PlasmicDialog = Object.assign(
  // Top-level PlasmicDialog renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    scrollableContent: makeNodeComponent("scrollableContent"),

    // Metadata about props expected for PlasmicDialog
    internalVariantProps: PlasmicDialog__VariantProps,
    internalArgProps: PlasmicDialog__ArgProps,
  }
);

export default PlasmicDialog;
/* prettier-ignore-end */
